import { render, staticRenderFns } from "./SubscriptionPlans.vue?vue&type=template&id=f1016d8c"
import script from "./SubscriptionPlans.vue?vue&type=script&lang=js"
export * from "./SubscriptionPlans.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionPlans.vue?vue&type=style&index=0&id=f1016d8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports